import {
  BG_STYLES,
  BORDER_STYLES,
  COMMON_STYLES,
  TEXT_STYLES,
  TYPOGRAPHY,
  VARIANTS_STYLES,
} from '@dehaat/dds'
import {
  CLAIM_STATUS,
  POLICY_CARD_STATUS,
  POLICY_STATUS,
  POLICY_STATUS_BG_COLOR,
} from '../../models/inusrance'
import { DIMENSION_WIDTH } from 'app/utils/common'
import React from 'react'
import { StyleSheet, View, Text } from 'react-native'

interface Props {
  policyName: string
  claimStatus: CLAIM_STATUS
  enrollmentId: string
  policyStatus: POLICY_STATUS
  coverType: string
  sumInsured: string
  premiumPaid: string
  costToFarmer: string
  policyStartDate: string
  policyEndDate: string
}

const InsuranceCard = ({
  policyName,
  claimStatus,
  enrollmentId,
  policyStatus,
  coverType,
  sumInsured,
  premiumPaid,
  costToFarmer,
  policyEndDate,
  policyStartDate,
}: Props) => {
  return (
    <View style={[COMMON_STYLES.b1, BORDER_STYLES.borderBlue20, styles.card]}>
      <View style={[COMMON_STYLES.row, BG_STYLES.bgNeutral20]}>
        <View
          style={[
            COMMON_STYLES.ph1,
            COMMON_STYLES['pv3/4'],
            COMMON_STYLES.flex1,
          ]}
        >
          <Text
            style={[
              TYPOGRAPHY.TEXT1,
              VARIANTS_STYLES.SEMI_EMPHASIZED,
              TEXT_STYLES.textNeutral100,
            ]}
          >
            {policyName}
          </Text>
          <Text
            style={[
              TYPOGRAPHY.CAPTION1,
              VARIANTS_STYLES.SEMI_EMPHASIZED,
              TEXT_STYLES.textNeutral80,
            ]}
          >
            {enrollmentId}
          </Text>
        </View>
        <View>
          <Text
            style={[
              TYPOGRAPHY.CAPTION1,
              VARIANTS_STYLES.MEDIUM,
              BG_STYLES[POLICY_STATUS_BG_COLOR[policyStatus]],
              TEXT_STYLES.textWhite,
              COMMON_STYLES['ph5/4'],
              COMMON_STYLES['pv1/2'],
              styles.policyStatus,
            ]}
          >
            {POLICY_CARD_STATUS[policyStatus]}
          </Text>
        </View>
      </View>

      <View
        style={[
          COMMON_STYLES['ph3/2'],
          COMMON_STYLES.pv1,
          BG_STYLES.bgWhite,
          COMMON_STYLES.flex1,
        ]}
      >
        {claimStatus === CLAIM_STATUS.IN_PROCESS && (
          <View
            style={[
              COMMON_STYLES['ph3/4'],
              COMMON_STYLES['pv1/2'],
              BG_STYLES.bgYellow100,
              COMMON_STYLES['br1/4'],
              COMMON_STYLES.mb1,
            ]}
          >
            <Text
              style={[
                TYPOGRAPHY.CAPTION1,
                VARIANTS_STYLES.MEDIUM,
                TEXT_STYLES.textNeutral90,
              ]}
            >
              Claim Status
            </Text>
            <Text
              style={[
                TYPOGRAPHY.TEXT2,
                VARIANTS_STYLES.SEMI_EMPHASIZED,
                TEXT_STYLES.textNeutral100,
              ]}
            >
              Claim in Process | Amount: ₹ 1800/-
            </Text>
          </View>
        )}
        {claimStatus === CLAIM_STATUS.TO_BE_EVALUATED && (
          <View
            style={[
              COMMON_STYLES['ph3/4'],
              COMMON_STYLES['pv1/2'],
              { backgroundColor: '#E3E3E3' },
              COMMON_STYLES['br1/4'],
              COMMON_STYLES.mb1,
            ]}
          >
            <Text
              style={[
                TYPOGRAPHY.TEXT2,
                VARIANTS_STYLES.SEMI_EMPHASIZED,
                TEXT_STYLES.textNeutral100,
              ]}
            >
              Claim will be evaluated after {policyEndDate}
            </Text>
          </View>
        )}
        {claimStatus === CLAIM_STATUS.UNDER_EVALUATION && (
          <View
            style={[
              COMMON_STYLES['ph3/4'],
              COMMON_STYLES['pv1/2'],
              BG_STYLES.bgBlue20,
              COMMON_STYLES['br1/4'],
              COMMON_STYLES.mb1,
            ]}
          >
            <Text
              style={[
                TYPOGRAPHY.TEXT2,
                VARIANTS_STYLES.SEMI_EMPHASIZED,
                TEXT_STYLES.textNeutral100,
              ]}
            >
              Claim under evaluation
            </Text>
          </View>
        )}

        <View style={[COMMON_STYLES.row, COMMON_STYLES.justifyBetween]}>
          <View>
            <Text
              style={[
                TYPOGRAPHY.CAPTION1,
                VARIANTS_STYLES.MEDIUM,
                TEXT_STYLES.textNeutral90,
              ]}
            >
              Cover Type
            </Text>
            <Text
              style={[
                TYPOGRAPHY.TEXT1,
                VARIANTS_STYLES.SEMI_EMPHASIZED,
                TEXT_STYLES.textNeutral100,
              ]}
            >
              {coverType}
            </Text>
          </View>
          <View>
            <Text
              style={[
                TYPOGRAPHY.CAPTION1,
                VARIANTS_STYLES.MEDIUM,
                TEXT_STYLES.textNeutral90,
              ]}
            >
              Sum Insured
            </Text>
            <Text
              style={[
                TYPOGRAPHY.TEXT1,
                VARIANTS_STYLES.SEMI_EMPHASIZED,
                TEXT_STYLES.textNeutral100,
              ]}
            >
              {`₹${sumInsured}/-`}
            </Text>
          </View>
        </View>
        <View style={COMMON_STYLES.mt1}>
          <Text
            style={[
              TYPOGRAPHY.CAPTION1,
              VARIANTS_STYLES.MEDIUM,
              TEXT_STYLES.textNeutral90,
            ]}
          >
            Premium Paid
          </Text>
          <View style={COMMON_STYLES.row}>
            <Text
              style={[
                TYPOGRAPHY.TEXT1,
                VARIANTS_STYLES.SEMI_EMPHASIZED,
                TEXT_STYLES.textNeutral100,
                Number(costToFarmer) === 0 && [
                  COMMON_STYLES.strikeText,
                  TEXT_STYLES.textNeutral70,
                ],
              ]}
            >
              {`₹${Number(costToFarmer) === 0 ? premiumPaid : costToFarmer}/-`}
            </Text>
            {Number(costToFarmer) === 0 && (
              <Text
                style={[
                  TYPOGRAPHY.TEXT1,
                  VARIANTS_STYLES.SEMI_EMPHASIZED,
                  TEXT_STYLES.textSuccess100,
                  COMMON_STYLES['ml1/4'],
                ]}
              >
                FREE
              </Text>
            )}
          </View>
        </View>
        <View style={COMMON_STYLES.mt1}>
          <Text
            style={[
              TYPOGRAPHY.CAPTION1,
              VARIANTS_STYLES.MEDIUM,
              TEXT_STYLES.textNeutral90,
            ]}
          >
            Risk Period
          </Text>
          <Text
            style={[
              TYPOGRAPHY.TEXT1,
              VARIANTS_STYLES.SEMI_EMPHASIZED,
              TEXT_STYLES.textNeutral100,
            ]}
          >
            from {policyStartDate} to {policyEndDate}
          </Text>
        </View>
      </View>
    </View>
  )
}

const styles = StyleSheet.create({
  card: {
    borderRadius: 12,
    overflow: 'hidden',
    width: Math.min(344, DIMENSION_WIDTH - 48),
  },
  policyStatus: {
    borderBottomLeftRadius: 8,
  },
})

export default InsuranceCard
